<template>
  <div class="activity-banner-container">
    <div class="activity-grid">
      <div 
        v-for="(item, index) in activityList" 
        :key="index" 
        class="grid-item" 
        :class="item.size"
        :style="{ background: item.color }"
        @click="handleItemClick(item)"
      >
        <img :src="item.image" class="grid-image" :alt="item.name" />
        <!-- <div class="grid-text">{{ item.name }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityBanner',
  data() {
    return {
      activityList: [
        {
          name: '美的',
          size: 'large',
          color: '#4CAF50',
          image: 'https://bank.giftoceanmall.com/6d971202605271611108096.jpg',
          path:'/search?keyword=美的'
        },
        {
          name: '追觅',
          size: 'small',
          color: '#f44336',
          image: 'https://bank.giftoceanmall.com/a281e202605271611528049.jpg',
          path:'/search?keyword=追觅'
        },
        {
          name: '海尔',
          size: 'small',
          color: '#1B5E20',
          image: 'https://bank.giftoceanmall.com/25730202605271612056207.jpg',
          path:'/search?keyword=海尔'
        },
        {
          name: '投资黄金',
          size: 'small',
          color: '#E91E63',
          image: 'https://bank.giftoceanmall.com/6604c20260527161215329.jpg',
          path:'/goods_collection_list/18'
        },
        {
          name: '摩米士',
          size: 'small',
          color: '#2196F3',
          image: 'https://bank.giftoceanmall.com/71726202605271612311774.jpg',
          path:'/search?keyword=摩米士'
        }
      ]
    }
  },
  methods: {
    handleItemClick(item) {
      this.$router.push(item.path)
      // this.$router.push(item.path)
      this.$emit('itemClick', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-banner-container {
  width: 100%;
  // margin-top: 0.2rem;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1.8rem);
  gap: 0.15rem;
}

.grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  
  &.large {
    grid-row: span 2;
    grid-column: span 1;
  }
  
  &.small {
    grid-row: span 1;
    grid-column: span 1;
  }
  
  &:active {
    opacity: 0.8;
    transform: scale(0.98);
  }
}

.grid-image {
  width: 100%;
  // height: 1.9rem;
  object-fit: cover;
}

.grid-text {
  position: absolute;
  color: #fff;
  font-size: 0.32rem;
  font-weight: bold;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .activity-grid {
    gap: 0.12rem;
  }
  
  .grid-text {
    font-size: 0.28rem;
  }
}
</style>